import type { Maybe } from '@adornis/base/utilTypes.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { DateTime } from 'luxon';
import { ChancenwerkUser } from './master-data-management/users/entities/ChancenwerkUser.js';

@Entity()
export class CRMEditRecord extends AdornisEntity {
  public static override _class = 'CRMEditRecord';

  public static override get allFields() {
    return {
      user: { vorname: 1, nachname: 1, email: 1 },
      userID: 1,
      when: 1,
      comment: 1,
    } as BaseQLSelectionSet<CRMEditRecord>;
  }

  @DataLoadedField(() => ChancenwerkUser, ({ userID }) => userID)
  public user: Maybe<ChancenwerkUser>;

  @Field(() => String)
  public userID: Maybe<string>;

  @Field(() => DateTime)
  public when: Maybe<DateTime>;

  @Field(() => String)
  public comment: Maybe<string>;
}

/**
 * This entity handles all possible Flags, different entities might need, for crm selectabillity
 * @entity CRMFlags
 */
@Entity()
export class CRMFlags extends AdornisEntity {
  public static override _class = 'CRMFlags';

  public static override get allFields() {
    return {
      getAll: 1,
      getsInfoAnniversary: 1,
      getsInfoAnniversaryRecord: CRMEditRecord.allFields,
      getsYearlyReport: 1,
      getsYearlyReportRecord: CRMEditRecord.allFields,
      getsChristmascard: 1,
      getsChristmascardRecord: CRMEditRecord.allFields,
      deferred: 1,
    } as BaseQLSelectionSet<CRMFlags>;
  }

  @Field(() => Boolean)
  public deferred: Maybe<boolean>;

  @Field(() => Boolean)
  public getAll: Maybe<boolean>;

  @Field(() => Boolean)
  public getsInfoAnniversary: Maybe<boolean>;

  @Field(() => CRMEditRecord)
  public getsInfoAnniversaryRecord: Maybe<CRMEditRecord>;

  @Field(() => Boolean)
  public getsYearlyReport: Maybe<boolean>;

  @Field(() => CRMEditRecord)
  public getsYearlyReportRecord: Maybe<CRMEditRecord>;

  @Field(() => Boolean)
  public getsChristmascard: Maybe<boolean>;

  @Field(() => CRMEditRecord)
  public getsChristmascardRecord: Maybe<CRMEditRecord>;

  public static getReadableNameForField(fieldName: string) {
    const readableNameMap = {
      getAll: 'Alle ohne Eintrag oder mit Nein',
      getsInfoAnniversary: 'Jubiläumskartenversand',
      getsYearlyReport: 'Jahresberichtversand',
      getsChristmascard: 'Weihnachtskartenversand',
    };

    return readableNameMap[fieldName] ?? '';
  }

  public isActive() {
    const flagFields = Object.keys(this.fields).filter(f => f !== '_class');

    for (const field of flagFields) {
      if (this[field] !== null) {
        if (this[field]) return true;
      }
    }

    return false;
  }

  public getFirstActiveField() {
    const flagFields = Object.keys(this.fields).filter(f => f !== '_class');
    for (const field of flagFields) {
      if (this[field] !== null) {
        if (this[field]) return field;
      }
    }

    return '';
  }
}
